jQuery( document ).ready(function( $ ) {
  (function () {
  var MOBILE_MAX = 767;
  if (window.innerWidth > MOBILE_MAX) return;

  // --- Hand icon (inherits white from pill via currentColor) ---
  var ICON = [
    '<svg class="swipe-hint__icon" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">',
      '<path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"></path>',
      '<path d="M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"></path>',
      '<path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"></path>',
      '<path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"></path>',
    '</svg>'
  ].join('');

  var HINT_HTML = [
    '<div class="swipe-hint" role="status" aria-live="polite">',
      '<span class="swipe-hint__pill">', ICON, '<span>Swipe for more</span>',
      '</span>',
    '</div>'
  ].join('');

  // ---- Helpers ----
  function ensureRel(el){
    var cs = window.getComputedStyle(el);
    if (cs.position === 'static') el.style.position = 'relative';
  }

  // Count unique media in this stage (ignores clones & duplicates)
  function uniqueSlideCount(stage){
    var items = Array.prototype.slice.call(stage.querySelectorAll('.owl-item:not(.cloned)'));
    if (!items.length) return 0;

    var keys = new Set();
    items.forEach(function(item){
      // Prefer <img> src/srcset/data-src; fallback to video/poster; else the item HTML
      var img = item.querySelector('img');
      var key = null;
      if (img) {
        key = img.getAttribute('data-src') || img.getAttribute('data-original') ||
              (img.currentSrc && img.currentSrc.split('?')[0]) ||
              (img.src && img.src.split('?')[0]) ||
              img.getAttribute('srcset') || img.getAttribute('data-srcset');
      } else {
        var vid = item.querySelector('video, source');
        if (vid) key = vid.getAttribute('src') || vid.getAttribute('poster');
      }
      if (!key) key = item.innerHTML.replace(/\s+/g,' ').slice(0,200); // coarse fallback
      keys.add(key);
    });
    return keys.size;
  }

  function injectForCarousel(stage){
    if (!stage || stage.dataset.swipeHintDone === '1') return;

    // Only show if there are 2+ unique slides
    if (uniqueSlideCount(stage) < 2) return;

    var firstVisible = stage.querySelector('.owl-item.active') || stage.querySelector('.owl-item');
    if (!firstVisible) return;

    ensureRel(firstVisible);
    if (firstVisible.querySelector('.swipe-hint')) return;

    firstVisible.insertAdjacentHTML('beforeend', HINT_HTML);
    stage.dataset.swipeHintDone = '1';

    var hint = firstVisible.querySelector('.swipe-hint');
    var dismissed = false;
    function dismiss(){
      if (dismissed) return; dismissed = true;
      if (hint){
        hint.style.transition='opacity .2s ease';
        hint.style.opacity='0';
        setTimeout(function(){ hint && hint.remove(); }, 220);
      }
    }

    var carousel = stage.closest('.owl-carousel') || stage.parentElement;
    if (window.jQuery && carousel) {
      var $c = jQuery(carousel);
      $c.one('drag.owl.carousel', dismiss);
      $c.one('changed.owl.carousel', dismiss);
    }
    (carousel || stage).addEventListener('touchstart', dismiss, { once:true, passive:true });
    (carousel || stage).addEventListener('click', dismiss, { once:true });

    setTimeout(dismiss, 5000);
  }

  function scanAll(){
    document.querySelectorAll('.owl-stage').forEach(injectForCarousel);
  }

  // Initial + retries + observe dynamic sections
  scanAll();
  var tries = 0, iv = setInterval(function(){ tries++; scanAll(); if (tries > 20) clearInterval(iv); }, 300);
  try { new MutationObserver(scanAll).observe(document.body, { childList:true, subtree:true }); } catch(e){}
})();
});